import { render, staticRenderFns } from "./thirdconfig.vue?vue&type=template&id=3bfec1fe&"
import script from "./thirdconfig.vue?vue&type=script&lang=js&"
export * from "./thirdconfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports